import {
  KEY_MANAGEMENT_START,
  KEY_MANAGEMENT_SUCCESS,
  KEY_MANAGEMENT_END,
  KEY_MANAGEMENT_OUTKEYS_SUCCESS,
  KEY_MANAGEMENT_TEAM_STATUS,
} from '../actions/keyManagement/keyManagement.actionType';

const initialState = {
  allKeys: {},
  isProcessing: false,
  teamStatus: {},
};

const KeyManagementReducer = (state = initialState, action) => {
  switch (action.type) {
    case KEY_MANAGEMENT_START: {
      return {
        ...state,
        isProcessing: true,
      };
    }

    case KEY_MANAGEMENT_SUCCESS: {
      return {
        ...state,
        allKeys: action.payload,
        isProcessing: false,
      };
    }
    case KEY_MANAGEMENT_END: {
      return {
        ...state,
        isProcessing: false,
      };
    }
    case KEY_MANAGEMENT_OUTKEYS_SUCCESS: {
      return {
        ...state,
        toasterData: action.payload,
        isProcessing: false,
      };
    }
    case KEY_MANAGEMENT_TEAM_STATUS: {
      return {
        ...state,
        teamStatus: action.payload,
      };
    }
    default:
      return state;
  }
};

export default KeyManagementReducer;
